import React from "react";
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { FaRegQuestionCircle } from "react-icons/fa";
import { PaybackPeriodItems } from "../../contexts/constants";
import { useTranslation } from "react-i18next";

// レベルに応じたインデント（px）を取得
const getLevelIndent = (level: number): number => {
  switch (level) {
    case 1: return 0;
    case 2: return 6;
    default: return 0;
  }
};

/**
 * 回収期間の項目説明ポップオーバー
 *
 * 使用例:
 * <PaybackPeriodPopover />
 */
interface PaybackPeriodPopoverProps {
  /** 簡易モードか（true時は営業利益・償却費の説明をサマリー由来の文言に変更） */
  isSimpleMode?: boolean;
}

export const PaybackPeriodPopover: React.FC<PaybackPeriodPopoverProps> = ({ isSimpleMode = false }) => {
  const { t } = useTranslation();
  const p = "features.InvestmentScreening.Popover.paybackPeriodExplanation.desc";
  const paybackPeriodExplanationData = [
    { symbol: "A", item: PaybackPeriodItems.capexAmount, description: t(`${p}.capexScreenInput`) },
    { symbol: "B", item: PaybackPeriodItems.operatingProfit, description: isSimpleMode ? t(`${p}.simpleProfit`) : t(`${p}.plItem21`) },
    { symbol: "C", item: PaybackPeriodItems.interestRate, description: t(`${p}.interestRateFormula`) },
    { symbol: "D", item: PaybackPeriodItems.equipmentDepreciation, description: isSimpleMode ? t(`${p}.simpleDepreciation`) : t(`${p}.plItem14`) },
    { symbol: "E", item: PaybackPeriodItems.paybackPeriod, description: t(`${p}.paybackFormula`) },
  ];

  return (
    <Popover placement="right">
      <PopoverTrigger>
        <button style={{ background: 'none', border: 'none', padding: 0 }}>
          <FaRegQuestionCircle size="30px" cursor="pointer" />
        </button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent width="1000px" maxH="600px" overflowY="auto" bgColor="#fffff0">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader fontWeight="bold">{t('features.InvestmentScreening.Popover.paybackPeriodExplanation.title')}</PopoverHeader>
          <PopoverBody>
            <Table size="sm" variant="simple">
              <Thead>
                <Tr>
                  <Th w="60px">{t('common.label.symbol')}</Th>
                  <Th w="300px">{t('common.label.item')}</Th>
                  <Th>{t('common.label.description')}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {paybackPeriodExplanationData.map((row, index) => (
                  <Tr key={index}>
                    <Td>{row.symbol}</Td>
                    <Td
                      fontWeight={row.item.level === 1 ? "bold" : "normal"}
                      pl={getLevelIndent(row.item.level)}
                    >
                      {row.item.name}
                    </Td>
                    <Td>{row.description}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
